module.exports = __webpack_public_path__ + "img/1f986.d7e8282.svg";